import { Preferences } from '@capacitor/preferences';
import WithBootedClient from '../lib/WithBootedClient';
import EventStreamer from '../lib/EventStreamer';

const storageName = '@settings';

interface IState {
  [key: string]: any;
}

enum SETTINGS_ENUM {
  'REMOTE_CONFIG',
  'LANGUAGE',
  'FIRST_TIME',
  'SECURITY_PIN',
  'FIRST_TIME_LOSS_PLAN',
  'LOSSPLAN_TASK_ID',
  'STORE_IS_OPEN',
  'TASK_CI_FINISHED',
  'PUSH_TOKEN',
  'HIERARCHY',
  'INITIAL_FILTER_SUGGESTED_PRODUCTS',
  'SUGGESTED_PRODUCTS',
  'FILTER_SUGGESTED_PRODUCTS',
  'IS_PDA',
  'TIME_LAST_SEEN'
}

export type SettingTypes = keyof typeof SETTINGS_ENUM;

class SettingsClient extends WithBootedClient {
  state: IState = {};

  async boot() {
    const cached = await Preferences.get({key: storageName});
    if (cached && cached.value) {
      const newState = JSON.parse(cached.value);
      await this.setState(newState);
    }
  }

  get(name: SettingTypes, defaultValue: any = null) {
    let setting = this.state[name];
    if (typeof setting == 'undefined') {
      return defaultValue;
    }

    return setting;
  }

  async set(name: SettingTypes, value: any) {
    this.state[name] = value;

    await this.setState(this.state);

    await Preferences.set({
      key: storageName,
      value: JSON.stringify(this.state)
    });

    EventStreamer.emit('SETTINGS_CHANGED', [name, value]);
    return value;
  }

  async remove(name: SettingTypes) {
    delete this.state[name];

    await this.setState(this.state);

    await Preferences.set({
      key: storageName,
      value: JSON.stringify(this.state)
    });

    EventStreamer.emit('SETTINGS_REMOVED', [name]);
    return true;
  }

  private async setState(newState: IState): Promise<void> {
    this.state = newState;
  }
}

export default new SettingsClient();
